"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafePairOfHandsStrategy = exports.SafePairOfHandsMode = void 0;
var SafePairOfHandsMode;
(function (SafePairOfHandsMode) {
    SafePairOfHandsMode["DISABLED"] = "DISABLED";
    SafePairOfHandsMode["AUTO"] = "AUTO";
})(SafePairOfHandsMode || (exports.SafePairOfHandsMode = SafePairOfHandsMode = {}));
var SafePairOfHandsStrategy;
(function (SafePairOfHandsStrategy) {
    SafePairOfHandsStrategy["TOWARD_TEAMMATE"] = "TOWARD_TEAMMATE";
    SafePairOfHandsStrategy["AWAY_FROM_THREAT"] = "AWAY_FROM_THREAT";
    SafePairOfHandsStrategy["TOWARD_ENDZONE"] = "TOWARD_ENDZONE";
    SafePairOfHandsStrategy["AWAY_FROM_SIDELINE"] = "AWAY_FROM_SIDELINE";
    SafePairOfHandsStrategy["SAFE_SQUARE"] = "SAFE_SQUARE";
    SafePairOfHandsStrategy["RANDOM"] = "RANDOM";
    SafePairOfHandsStrategy["CUSTOM"] = "CUSTOM";
})(SafePairOfHandsStrategy || (exports.SafePairOfHandsStrategy = SafePairOfHandsStrategy = {}));
